(function () {
  document.addEventListener(
    'click',
    function (event) {
      var arrow = event.target.closest('xo-carousel-prev, xo-carousel-next');
      if (!arrow) return;
      if (!arrow.closest('xo-container')) return;
      if (arrow.tagName === 'XO-CAROUSEL-PREV' && typeof arrow.prevSlide === 'function') {
        arrow.prevSlide();
      } else if (arrow.tagName === 'XO-CAROUSEL-NEXT' && typeof arrow.nextSlide === 'function') {
        arrow.nextSlide();
      }
    },
    true
  );
})();
